import React from "react"

import { NotificationManager } from "react-notifications"

import { gql, useMutation } from "hooks/urql"

import InlineConfirmation from "components/InlineConfirmation"

const ResendInterviewInstructions = ({ id }) => {
  const [, runMutation] = useMutation(resendInstructionsMutation)
  const handleSubmit = () => {
    return runMutation({ id }).then(result => {
      if (result.error) {
        NotificationManager.error(result.error.message)
        return
      }

      const { failures } =
        result.data.tutorApplicationResendInterviewInstructions
      if (failures) {
        NotificationManager.error(failures.map(f => f.message).join(", "))
      } else {
        NotificationManager.info(
          "Interview instructions will be re-sent momentarily"
        )
      }
    })
  }

  return (
    <InlineConfirmation
      handleSubmit={handleSubmit}
      buttonText="Re-send Interview Instructions"
      type="info"
    />
  )
}

const resendInstructionsMutation = gql`
  mutation ($id: ID!) {
    tutorApplicationResendInterviewInstructions(id: $id) {
      failures {
        message
      }
      tutorApplication {
        id
      }
    }
  }
`

export default ResendInterviewInstructions
